<template>
  <v-select
    v-bind="$attrs"    
    :items="paymentMethodItems"
    v-model="selectedValue"
    no-data-text="You don't have any previous cards on file..."
  />
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'PaymentMethodSelect',

  props: ['value'],

  data: () => ({
    selectedValue: null,
  }),

  computed: {
    ...mapGetters('payment_methods', ['paymentMethods']),

    paymentMethodItems() {
      return this.paymentMethods.map( (pm) => { 
        return { 
          text: `${ this.brandWord(pm.brand) } ending in ${ pm.last4 }`,
          value: pm.payment_method_id,
        } 
      })
    },
  },

  watch: {
    value() { this.selectedValue = this.updateSelected() },
    paymentMethods() { this.selectedValue = this.updateSelected() },

    selectedValue(newVal) {
      this.$emit('input', newVal)
    },
  },

  methods: {
    ...mapActions('payment_methods', ['loadPaymentMethods']),
    ...formatters,

    updateSelected() {
      const methodSet = this.paymentMethods.map( pm => pm.payment_method_id)
      if (methodSet.includes(this.value)) {
        return this.value
      }

      const defaultMethod = this.paymentMethods.find( pm => pm.default )
      if (defaultMethod) {
        return defaultMethod.payment_method_id
      }

      return null
    },
  },
  
  async created() {
    await this.loadPaymentMethods()
  }
}
</script>